export class OptionOriginCode {
 customerAcronym!: string;
 updateDatetime!:string;
 reportDate!:string;
 customerId!:string;
 orderCount!:string;
 MTDAvgCount!:string;
 thirtyDayMovingAvg!:string;
 updateUser!:string;
 clearingAccountCode!:string;
 clearingAccountCode2!:string;
 firmMPID!:string;
 customerName!:string;
}

export class OptionOriginCodeGraph {
    sumOfOrderCount!: Array<number>;
    reportDate!: Array<string>;
    sumOfThirtyDayAvgCount!: Array<number>;
    sumOfMTDAvgCount!: Array<number>;
  }

  export class CmtaDetail {
    
      cmtaAccount!: number;
      callPut!: string;
      commissionRate!: number;
      quantity!: number;
      orderId!: string;
      accountCategory!: string;
      enteredDate!: string;
      orderFlags!: string;
      osiCode!: string;
      commissionMethod!: string;
      enteredBy!: string;
      versionNumber!: number;
      buysell!: string;
      expiryDate!: string;
      counterpartyCode!: string;
      openClose!: string;
      underlyingSymbol!: string;
      price!: number;
      orderLegId!: number;
      cmtaBroker!: number;
      giveupBroker!:string ;
      strikePrice!: number
    
  }